import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { AnimateIn } from "./AnimateIn";
import JsonData from "../data/data.json";
import "./ProductShowcase.css";

const productImages = {
  medilens: "/img/illustrations/medilens-preview.svg",
  mediline: "/img/illustrations/mediline-preview.svg",
  mediagents: "/img/illustrations/mediagents-preview.svg",
};

const detailsMap = {};
(JsonData.ProductDetails || []).forEach((d) => {
  detailsMap[d.name] = d;
});

export const ProductShowcase = ({ data }) => {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  const items = data?.items || [];
  const total = items.length;

  const next = useCallback(() => {
    setActive((prev) => (prev + 1) % total);
  }, [total]);

  useEffect(() => {
    if (paused || total === 0) return;
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [paused, total, next]);

  if (!data || total === 0) return null;

  const product = items[active];
  const slug = product.slug;
  const details = detailsMap[product.name] || {};

  return (
    <section id="products" className="showcase-section">
      <div className="section-container">
        <AnimateIn variant="fadeUp">
          <div className="showcase-header">
            <p className="eyebrow">{data.eyebrow}</p>
            <h2 className="section-title">{data.title}</h2>
          </div>
        </AnimateIn>

        <div className="showcase-tabs">
          {items.map((item, i) => (
            <button
              key={i}
              className={`showcase-tab ${i === active ? 'active' : ''}`}
              onClick={() => { setActive(i); setPaused(true); }}
            >
              <span className="showcase-tab-name">{item.name}</span>
              <span className="showcase-tab-sub">{item.subtitle}</span>
              {i === active && !paused && (
                <span className="showcase-tab-progress" key={`prog-${active}`} />
              )}
            </button>
          ))}
        </div>

        <div
          className="showcase-content"
          key={active}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {/* Title + description */}
          <div className="showcase-title-bar">
            <h3 className="showcase-product-name">{product.name}</h3>
            <p className="showcase-title-desc">{product.description}</p>
          </div>

          {/* Full-width image */}
          <div className="showcase-image-area">
            <img
              src={productImages[slug]}
              alt={product.name}
              className="showcase-image"
            />
          </div>

          {/* Highlights as horizontal cards + CTA */}
          {details.highlights && (
            <div className="showcase-bottom">
              <ul className="showcase-highlights">
                {details.highlights.map((h, j) => (
                  <li key={j}>{h}</li>
                ))}
              </ul>
              <div className="showcase-cta-row">
                <Link to={`/products/${slug}`} className="showcase-cta primary">
                  詳しく見る →
                </Link>
              </div>
            </div>
          )}
        </div>

        <div className="showcase-dots">
          {items.map((_, i) => (
            <button
              key={i}
              className={`showcase-dot ${i === active ? 'active' : ''}`}
              onClick={() => { setActive(i); setPaused(true); }}
              aria-label={`Product ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
